import React from 'react';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  accentColor?: string;
  badge?: string;
}

export default function SectionHeader({ icon, title, subtitle, accentColor, badge }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span
          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: `${accentColor}18`, border: `1px solid ${accentColor}30` }}
        >
          {icon}
        </span>
        <div>
          <div className="flex items-center gap-2">
            <h2 className="section-header">{title}</h2>
            {badge && (
              <span
                className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                style={{ background: 'rgba(245, 158, 11, 0.15)', color: 'var(--premium)', border: '1px solid rgba(245, 158, 11, 0.3)' }}
              >
                {badge}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}